import * as React from 'react';
import OrderDetailRequested from '../../../application/order/events/OrderDetailRequested';
import { Link } from 'react-router-dom';
import ViewOrder from './ViewOrder';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../../application/core/DispatchProps';
import State from '../../../application/core/State';

interface MatchParams {
    orderId: string;
    customerId: string;
}

interface StateProps {
    prevLocation: string;
}

interface Props extends RouteComponentProps<MatchParams>, DispatchProps, StateProps {
    goBackLink: JSX.Element;
}

class CustomerOrder extends React.PureComponent<Props> {
    public componentDidMount(): void {
        this.props.dispatch(new OrderDetailRequested(this.props.match.params.orderId, this.props.match.params.customerId));
    }

    public render(): JSX.Element {
        return this.props.prevLocation === '/admin/integration-panel' ? (
            <ViewOrder goBackLink={<Link to={`/admin/integration-panel`}> &larr; Back to panel</Link>} />
        ) : (
            <ViewOrder goBackLink={<Link to={`/admin/customers/${this.props.match.params.customerId}`}> &larr; Back to customer</Link>} />
        );
    }
}

const mapStateToProps = (state: State): StateProps => ({
    prevLocation: state.application.prevLocation
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerOrder);



// WEBPACK FOOTER //
// ./src/view/order/details/CustomerOrder.tsx